import React from "react";
import { motion } from "framer-motion";
import bgImg from "../Images/breadcrumb-bg.webp";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.15,
    },
  },
};

const heading = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Breadcrumb = ({ title, description, large = false }) => {
  return (
    <motion.section
     className={`breadcrumb-section container ${large ? "breadcrumb-large" : ""}`}
      style={{ backgroundImage: `url(${bgImg})` }}
      initial={{ scale: 1.08 }}
      whileInView={{ scale: 1 }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <motion.div
        className="breadcrumb-content"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h1 variants={heading}>
          {title}
        </motion.h1>

        {description && (
          <motion.p
            className="breadcrumb-desc"
            variants={heading}
          >
            {description}
          </motion.p>
        )}
      </motion.div>
    </motion.section>
  );
};

export default Breadcrumb;